import { apiPost } from "../baseApi";
import { setBuildingData } from "service/mapper";

export const create = async (data) => {
  try {
    const response = await apiPost("_building", data);
    return { ...response, data: setBuildingData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
